<fieldset class="outer-box">
    <legend class="box-label">FTP Service</legend>
    <form [formGroup]="form">
        <div class="grid">
        <mat-form-field appearance="outline">
            <mat-label>FTP Server Type</mat-label>
            <mat-select formControlName="ftpServerType">
                <mat-option *ngFor="let ftpServerType of FtpServerTypes" [value]="ftpServerType">
                    {{FtpServerTypeUtil.toString(ftpServerType)}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>FTP Server Location</mat-label>
            <input matInput formControlName="ftpServerLocation" placeholder="sftp.evidant.com" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Username</mat-label>
            <input matInput formControlName="userName" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Control Port</mat-label>
            <input matInput type="number" formControlName="controlPort" />
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="testConnection()" class="connectionbutton">Test Connection</button>
        </div>
    </form>
</fieldset>